module.exports = __webpack_public_path__ + "static/media/picture.65f6acae.svg";